module.exports = __webpack_public_path__ + "img/France.4aae7f02.svg";